import { Environment } from "./env";

export const StageEnvironment: Environment = {
  base_url: "https://aaneelconnect-api-sandbox.aaneelconnect.com",
  temp_base_url: "https://aaneelconnect-api-sandbox.aaneelconnect.com",
};
